import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { BUSINESS } from "../lib/data";
import logoMark from "../assets/releaf_mark.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest text-ivory">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:px-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-14 items-center justify-center rounded-md bg-ivory p-1.5">
              <img src={logoMark} alt="Releaf monogram" className="h-full w-auto" />
            </span>
            <span>
              <span className="block font-serif text-xl">Releaf</span>
              <span className="block text-[9px] font-semibold uppercase tracking-[0.2em] text-gold">
                Wellness &amp; Aesthetics
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-ivory/70">
            Injectables, hormone therapy and wellness care with Nichole Olsen,
            Nurse Practitioner — inside Salon 406, North Ogden.
          </p>
        </div>

        <div>
          <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">
            Get in Touch
          </h3>
          <ul className="mt-5 space-y-3 text-sm text-ivory/80">
            <li>
              <a data-testid="footer-phone-link" href={BUSINESS.phoneHref} className="flex items-center gap-3 transition-colors hover:text-gold">
                <Phone size={15} className="text-ivory/60" /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a data-testid="footer-email-link" href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 transition-colors hover:text-gold">
                <Mail size={15} className="text-ivory/60" /> {BUSINESS.email}
              </a>
            </li>
            <li>
              <a data-testid="footer-instagram-link" href={BUSINESS.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold">
                <Instagram size={15} className="text-ivory/60" /> {BUSINESS.instagram}
              </a>
            </li>
            <li>
              <a data-testid="footer-map-link" href={BUSINESS.mapsUrl} target="_blank" rel="noreferrer" className="flex items-start gap-3 transition-colors hover:text-gold">
                <MapPin size={15} className="mt-0.5 shrink-0 text-ivory/60" />
                <span>{BUSINESS.addressLines.join(", ")}</span>
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">
            Book a Visit
          </h3>
          <ul className="mt-5 space-y-2.5 text-sm text-ivory/80">
            <li>In-person consultation — Complimentary</li>
            <li>Phone consultation — $60</li>
            <li>Neurotoxin — $14/unit</li>
            <li>Cannabis card (new) — $125</li>
            <li>Cannabis renewal (telehealth) — $75</li>
          </ul>
          <Link
            to="/book"
            data-testid="footer-book-button"
            className="mt-6 inline-block rounded-md bg-ivory px-6 py-3 text-sm font-semibold text-forest transition-colors duration-300 hover:bg-cream"
          >
            Book Your Consultation
          </Link>
          <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-sm text-ivory/80">
            <Link to="/gift" data-testid="footer-gift-link" className="transition-colors hover:text-gold">Gift Certificates</Link>
            <Link to="/portal" data-testid="footer-portal-link" className="transition-colors hover:text-gold">Patient Portal</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-ivory/50 sm:flex-row sm:px-8">
          <p>&copy; {new Date().getFullYear()} Releaf Wellness &amp; Aesthetics. All rights reserved.</p>
          <Link data-testid="footer-admin-link" to="/admin/login" className="transition-colors hover:text-gold">
            Provider Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
